import { MARQUEE_ITEMS } from "../data/site";

export const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="services-marquee"
      aria-hidden="true"
      className="overflow-hidden border-y border-white/[0.07] bg-[#080d17] py-5"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center whitespace-nowrap text-sm font-bold tracking-[0.28em] text-[#9fd3f0]/70"
              >
                <span className="px-8">{item}</span>
                <span className="h-1.5 w-1.5 rotate-45 bg-white/20" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
